import * as React from "react";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

import axios from "axios";
import Joi from "joi";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxHeight: "700px",
  overflowY: "scroll",
  overflowX: "hidden",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const initialRequestId = {
  name: "",
  record: null,
  language: "",
};
export default function UpdatePopUp({
  setUpdatePopUp,
  updatePopUp,
  sound,
  id,
  setSound,
  getSounds,
}) {
  const [errorList, setErrorList] = useState(null);
  const [apiErrors, setApiErrors] = useState(null);
  const [isLoading, setloading] = useState(false);
  const [requestData, setRequestData] = useState({
    ...initialRequestId,
  });
  useEffect(() => {
    let { name, language } = sound;
    setRequestData({ name, language });
  }, [sound]);
  const handleClose = () => {
    setUpdatePopUp(false);
    setSound("");
    setloading(false);
  };
  const handleFiles = (e) => {
    setRequestData({
      ...requestData,
      record: e.target.files[0],
    });
  };
  const handleChange = (event) => {
    setRequestData({
      ...requestData,
      [event.target.name]: event.target.value,
    });
  };

  const validateQuiz = (requestData) => {
    let schema = Joi.object({
      name: Joi.string().required().messages({
        "string.empty": `"name" can't be an empty field`,
        "any.required": `"name" is a required field`,
      }),
      record: Joi.object().optional().allow(null),
      language: Joi.string().required().messages({
        "string.empty": `"language" can't be an empty field`,
        "any.required": `"language" is a required field`,
      }),
    });

    return schema.validate(requestData, { abortEarly: false });
  };
  useEffect(() => {
    setApiErrors(null);
    setErrorList(null);
  }, [requestData]);
  let authToken = localStorage.getItem("userToken");

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    let valRes = validateQuiz(requestData);
    const formData = new FormData();
    formData.append("name", requestData.name);
    requestData.record && formData.append("record", requestData.record);
    formData.append("language", requestData.language);
    if (valRes.error) {
      setErrorList(valRes.error.details);
    } else {
      try {
        setloading(true);
        let { data } = await axios.post(
          `https://atfalunaapp.com/api/dashboard/sounds/${id}/update`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              "Content-Type": "multipart/form-data",
            },
            responseType: "json",
          }
        );

        if (data.message === "Successful") {
          setUpdatePopUp(false);
          setloading(false);
          getSounds();
          setRequestData({});
        }
      } catch (error) {
        setApiErrors(error.response.data.errors);
        setloading(false);
      }
    }
  };

  return (
    <div>
      <Modal
        open={updatePopUp}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: "scroll", overflowX: "visible", height: "100%" }}
      >
        <Box sx={style} className="position-relative">
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            className="text-center fw-bold mb-4"
          >
            Update Row
          </Typography>
          {errorList &&
            errorList.map((error, index) => {
              return (
                <div key={index} className="alert alert-danger">
                  {error.message}
                </div>
              );
            })}

          {apiErrors &&
            Object.keys(apiErrors).map((key) => (
              <div key={key} className="alert alert-danger">
                {key} must be {apiErrors[key][0].split(".")[1]}
              </div>
            ))}
          <div>
            <div className="mb-2">
              <label htmlFor="arTitle" className="form-label">
                Name
                <span className="required"> * </span>
                <span className="hide">This is a Required Feild</span>
              </label>
              <input
                className="form-control"
                type="text"
                id="arTitle"
                name="name"
                placeholder={sound.name}
                value={requestData.name}
                onChange={handleChange}
              />
            </div>
            <div className="mb-2">
              <label htmlFor="arAudio" className="form-label">
                Record <span className="required"> </span>
              </label>
              <input
                className="form-control"
                type="file"
                id="arAudio"
                accept="audio/wav,audio/mp3"
                name="record"
                onChange={handleFiles}
              />
            </div>

            <label htmlFor="arLang" className="form-label">
              Language
              <span className="required"> * </span>
              <span className="hide">This is a Required Feild</span>
            </label>
            <div className="input-group mb-3">
              <select
                className="form-select"
                id="arLang"
                name="language"
                value={requestData.language}
                onChange={handleChange}
              >
                <option defaultValue>Choose...</option>
                <option value={"ar"}>ar</option>
                <option value={"en"}>en</option>
              </select>
              <label className="input-group-text" htmlFor="inputGroupSelect02">
                Options
              </label>
            </div>
          </div>
          <div className="closeButtn">
            <CloseIcon className="closeIcon" onClick={handleClose} />
          </div>
          <div className="d-flex justify-content-center align-items-center mt-4">
            <button
              type="button"
              className="btn btn-light addBtn"
              onClick={handleFormSubmit}
            >
              {isLoading == true ? (
                <div className="d-flex align-items-center">
                  <span>Loading... </span>
                  <CircularProgress className="loadingIcon" />
                </div>
              ) : (
                "Update"
              )}
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
